module.exports = __webpack_public_path__ + "img/b002.6a09bfe2.jpg";